import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(32.000000, 25.000000)">
        <path
          d="M28.0909 13.0909C27.8182 10.7879 26.7121 9 24.7727 7.72727C22.8333 6.45454 20.4545 5.81818 17.6364 5.81818C15.5758 5.81818 13.7727 6.15151 12.2273 6.81818C10.697 7.48485 9.5 8.40151 8.63636 9.56818C7.78788 10.7348 7.36364 12.0606 7.36364 13.5455C7.36364 14.7879 7.65909 15.8561 8.25 16.75C8.85606 17.6288 9.62879 18.3636 10.5682 18.9545C11.5076 19.5303 12.4924 20.0076 13.5227 20.3864C14.553 20.75 15.5 21.0455 16.3636 21.2727L21.0909 22.5455C22.303 22.8636 23.6515 23.303 25.1364 23.8636C26.6364 24.4242 28.0682 25.1894 29.4318 26.1591C30.8106 27.1136 31.947 28.3409 32.8409 29.8409C33.7349 31.3409 34.1818 33.1818 34.1818 35.3636C34.1818 37.8788 33.5227 40.1515 32.2045 42.1818C30.9015 44.2121 28.9924 45.8258 26.4773 47.0227C23.9773 48.2197 20.9394 48.8182 17.3636 48.8182C14.0303 48.8182 11.1439 48.2803 8.70455 47.2045C6.2803 46.1288 4.37121 44.6288 2.97727 42.7045C1.59848 40.7803 0.818182 38.5455 0.636364 36H6.45455C6.60606 37.7576 7.19697 39.2121 8.22727 40.3636C9.27273 41.5 10.5909 42.3485 12.1818 42.9091C13.7879 43.4545 15.5152 43.7273 17.3636 43.7273C19.5152 43.7273 21.447 43.3788 23.1591 42.6818C24.8712 41.9697 26.2273 40.9848 27.2273 39.7273C28.2273 38.4545 28.7273 36.9697 28.7273 35.2727C28.7273 33.7273 28.2955 32.4697 27.4318 31.5C26.5682 30.5303 25.4318 29.7424 24.0227 29.1364C22.6136 28.5303 21.0909 28 19.4545 27.5455L13.7273 25.9091C10.0909 24.8636 7.21212 23.3712 5.09091 21.4318C2.9697 19.4924 1.90909 16.9545 1.90909 13.8182C1.90909 11.2121 2.61364 8.93939 4.02273 7C5.44697 5.04545 7.35606 3.5303 9.75 2.45454C12.1591 1.36363 14.8485 0.81818 17.8182 0.81818C20.8182 0.81818 23.4848 1.35606 25.8182 2.43182C28.1515 3.49242 30 4.94697 31.3636 6.79545C32.7424 8.64394 33.4697 10.7424 33.5455 13.0909H28.0909Z"
          fill="currentColor"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
